import styled from 'styled-components';

export const BottomRight = styled.div`
position: fixed;
bottom: 1em;
right: 1em;
`;
